import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Activity, Car, Plane } from 'lucide-react';

import imgPmr from '../assets/images/utils/photo_mobilite_reduite.jpeg';
import imgBus from '../assets/images/utils/bus.jpg';
import imgConv from '../assets/images/utils/taxi-conventionne.jpg.webp';
import imgAirport from '../assets/images/utils/airport_shuttle.jpg';

export const servicesData = [
    {
        id: 'pmr',
        title: 'Transport PMR',
        description: 'Service de transport adapté pour les personnes à mobilité réduite. Véhicules équipés de rampes et fixations pour fauteuils roulants.',
        fullDescription: 'Notre service de transport PMR est conçu pour offrir confort et sécurité. Nos chauffeurs sont formés pour accompagner les personnes en situation de handicap, assurant une prise en charge complète du domicile jusqu\'au lieu de rendez-vous. Nous disposons de véhicules spacieux et modulables, conformes aux normes de sécurité les plus strictes.',
        icon: <Heart size={60} />,
        image: imgPmr
    },
    {
        id: 'specialise',
        title: 'Centres Spécialisés',
        description: 'Accompagnement vers les CAMSP, CMP, CMPP et autres établissements spécialisés pour enfants et adultes.',
        fullDescription: 'Nous assurons les trajets quotidiens ou ponctuels vers les centres spécialisés (CAMSP, CMP, CMPP, IME...). Conscients des besoins spécifiques de nos passagers, nous garantissons ponctualité, bienveillance et une relation de confiance avec les familles et les établissements.',
        icon: <Activity size={60} />,
        image: imgBus
    },
    {
        id: 'conventionne',
        title: 'Transport Conventionné',
        description: 'Transport médical assis professionnalisé (TAP) remboursé par la CPAM pour vos rendez-vous médicaux.',
        fullDescription: '2ATP-MR est une société de transport conventionnée par la Sécurité Sociale. Nous réalisons vos transports médicaux (consultations, hospitalisations, séances de rééducation) avec dispense d\'avance de frais sur présentation de votre prescription médicale et carte vitale à jour.',
        icon: <Car size={60} />,
        image: imgConv
    },
    {
        id: 'aeroport',
        title: 'Transferts Gares & Aéroports',
        description: 'Navettes privées vers toutes les gares et aéroports d\'Île-de-France (Orly, Roissy CDG, Beauvais).',
        fullDescription: 'Voyagez l\'esprit tranquille avec notre service de transfert aéroport. Que ce soit pour un départ en vacances ou un déplacement professionnel, nous assurons votre transfert vers Orly, Roissy Charles de Gaulle, Beauvais ou les gares parisiennes. Accueil personnalisé, aide aux bagages et attente en cas de retard de vol inclus.',
        icon: <Plane size={60} />,
        image: imgAirport
    }
];

const Services = () => {
    return (
        <div className="section container">
            <h1 style={{ textAlign: 'center', marginBottom: '3rem' }}>Nos Services</h1>
            <div style={{ display: 'grid', gap: '4rem' }}>
                {servicesData.map((service, index) => (
                    <div key={service.id} style={{
                        display: 'flex',
                        flexDirection: index % 2 === 0 ? 'row' : 'row-reverse',
                        alignItems: 'center',
                        gap: '3rem',
                        backgroundColor: 'white',
                        padding: '2rem',
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px -5px rgba(0,0,0,0.1)'
                    }} className="service-card">
                        <div style={{ flex: 1 }}>
                            <img src={service.image} alt={service.title} style={{ borderRadius: '8px', width: '100%', objectFit: 'cover' }} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>{service.icon}</div>
                            <h2>{service.title}</h2>
                            <p style={{ fontSize: '1.1rem', color: 'var(--text-light)', marginBottom: '1.5rem' }}>
                                {service.description}
                            </p>
                            <Link to={`/services/${service.id}`} className="btn btn-primary">En savoir plus</Link>
                        </div>
                    </div>
                ))}
            </div>

            {/* Mobile responsive fix */}
            <style>{`
        @media (max-width: 768px) {
          .service-card {
            flex-direction: column !important;
            gap: 1.5rem !important;
          }
        }
      `}</style>
        </div>
    );
};

export default Services;
